import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { FiSearch, FiCalendar } from 'react-icons/fi';

interface Activity {
  id: number;
  action: string;
  entity_type: string;
  entity_id: string;
  created_at: string;
  employee_name: string;
}

const API_URL = process.env.REACT_APP_API_URL || 'https://api.liberianpost.com';

const ActivityLog: React.FC = () => {
  const [activities, setActivities] = useState<Activity[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchActivityLog();
  }, []);

  const fetchActivityLog = async () => {
    try {
      const response = await axios.get(`${API_URL}/employees/activity-log`);
      setActivities(response.data.data.logs);
    } catch (error) {
      console.error('Failed to fetch activity log:', error);
    } finally {
      setLoading(false);
    }
  };

  const getActionIcon = (action: string) => {
    const icons: Record<string, string> = {
      create_employee: '👤➕',
      update_employee: '👤✏️',
      register_user: '📝',
      assign_dssn: '🆔',
      freeze_user: '🔒',
      unfreeze_user: '🔓',
      approve_merchant: '✅',
      suspend_merchant: '⛔',
      reject_kyc: '❌',
      update_settings: '⚙️'
    };
    return icons[action] || '📋';
  };

  const filteredActivities = activities.filter(activity =>
    activity.action.toLowerCase().includes(search.toLowerCase()) ||
    activity.employee_name.toLowerCase().includes(search.toLowerCase()) ||
    activity.entity_type.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) {
    return (
      <div className="dashboard">
        <main className="main-content" style={{ marginLeft: 0 }}>
          <div className="loading">Loading activity log...</div>
        </main>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <main className="main-content" style={{ marginLeft: 0 }}>
        <div className="page-header">
          <h1>Activity Log</h1>
          <p>Track all employee actions and system events</p>
        </div>

        <div className="search-bar" style={{ marginBottom: 24, width: '100%', maxWidth: 400 }}>
          <FiSearch />
          <input
            type="text"
            placeholder="Search by action, employee, or entity..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="activity-timeline">
          {filteredActivities.map((activity) => (
            <div key={activity.id} className="activity-timeline-item">
              <div className="timeline-icon">
                {getActionIcon(activity.action)}
              </div>
              <div className="timeline-content glass">
                <div className="timeline-header">
                  <span className="timeline-action">{activity.action.replace(/_/g, ' ')}</span>
                  <span className="timeline-time">
                    <FiCalendar size={12} />
                    {new Date(activity.created_at).toLocaleString()}
                  </span>
                </div>
                <div className="timeline-details">
                  <span className="timeline-employee">{activity.employee_name}</span>
                  <span className="timeline-entity">
                    {activity.entity_type}: {activity.entity_id?.substring(0, 8)}...
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredActivities.length === 0 && (
          <div className="empty-state glass">
            <h3>No activities found</h3>
            <p>Try adjusting your search</p>
          </div>
        )}
      </main>
    </div>
  );
};

export default ActivityLog;
